import script from "./ArgonSearcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSearcher.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSearcher.vue?vue&type=style&index=0&id=9d1d2a78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d1d2a78"]])

export default __exports__